import type {SocialMedias} from "@/types/link.type";
import {CommandsEnum} from "@/types/link.type";

const socialMediaToTitleMap = {
    YOUTUBE : "YouTube",
    TIKTOK: "TikTok",
    TWITTER: "Twitter",
    INSTAGRAM : "Instagram",
    FACEBOOK : "Facebook",
    ONLYFANS : "OnlyFans",
    SOUNDCLOUD : "SoundCloud",
    SPOTIFY : "Spotify",
    TWITCH : "Twitch",
    DISCORD : "Discord",
    TELEGRAM : "Telegram",
    BEHANCE : "Behance",
    LINKEDIN : "LinkedIn",
    PINTEREST : "Pinterest",
    OTHER: "Other",
}

export function socialMediaEnumToTitle(sm: SocialMedias): string {
    return socialMediaToTitleMap[sm]
}


const commandsToTitleMap = {
    [CommandsEnum.YOUTUBE_SUBSCRIBE] : "Subscribe on YouTube",
    [CommandsEnum.YOUTUBE_LIKE_VIDEO] : "Like video",
    [CommandsEnum.YOUTUBE_POST_CMT] : "Comment on video",


    [CommandsEnum.TWITTER_FLW_USER] : "Follow user",
    [CommandsEnum.TWITTER_LIKE_TWT] : "Like tweet",
    [CommandsEnum.TWITTER_RPLY_TWT] : "Reply to tweet",
    [CommandsEnum.TWITTER_RETWEET] : "Retweet",

    [CommandsEnum.INSTAGRAM_FLW_USER] : "Follow user",
    [CommandsEnum.INSTAGRAM_LIKE_PST] : "Like post",
    [CommandsEnum.INSTAGRAM_POST_CMT] : "Post a comment",

    [CommandsEnum.FACEBOOK_LIKE_PAGE ] : "Like page",
    [CommandsEnum.FACEBOOK_LIKE_POST ] : "Like post",
    [CommandsEnum.FACEBOOK_POST_COMMENT] : "Post a comment",
    [CommandsEnum.FACEBOOK_SHARE_POST ] : "Share post",

    [CommandsEnum.TIKTOK_FLW_USER] : "Follow user",
    [CommandsEnum.TIKTOK_LIKE] : "Like",
    [CommandsEnum.TIKTOK_POST_CMT] : "Post a comment",

    [CommandsEnum.ONLYFANS_FOLLOW_USER] : "Follow user",

    [CommandsEnum.SOUNDCLOUD_FOLLOW_USER]: "Follow user",
    [CommandsEnum.SOUNDCLOUD_LIKE_TRACK] :"Like track",
    [CommandsEnum.SOUNDCLOUD_REPOST_TRACK] : "Repost track",

    [CommandsEnum.SPOTIFY_FOLLOW_ARTIST]: "Follow artist",
    [CommandsEnum.SPOTIFY_LIKE_SONG_OR_ALBUM]: "Like song or album",

    [CommandsEnum.TWITCH_FOLLOW]: "Follow",

    [CommandsEnum.DISCORD_JOIN_SERVER]: "Join server",

    [CommandsEnum.TELEGRAM_JOIN_CHANNEL]: "Join channel",

    [CommandsEnum.BEHANCE_FOLLOW]: "Follow",

    [CommandsEnum.LINKEDIN_CONNECT]: "Connect",
    [CommandsEnum.LINKEDIN_COMPANY_FOLLOW]: "Follow company",

    [CommandsEnum.PINTEREST_SAVE]: "Pin",
    [CommandsEnum.PINTEREST_FOLLOW]: "Follow",

    [CommandsEnum.OTHER_VISIT_PAGE]: "Visit page"

}
export function commandToTitle(command: CommandsEnum | string) {
    return commandsToTitleMap[command as CommandsEnum]
}


const commandToInputLabelMap = {
    [CommandsEnum.YOUTUBE_SUBSCRIBE] : "Enter a channel URL *",
    [CommandsEnum.YOUTUBE_LIKE_VIDEO] : "Enter a video URL *",
    [CommandsEnum.YOUTUBE_POST_CMT] : "Enter a video URL *",

    [CommandsEnum.TWITTER_FLW_USER] : "Enter a user URL *",
    [CommandsEnum.TWITTER_LIKE_TWT] : "Enter a tweet URL *",
    [CommandsEnum.TWITTER_RPLY_TWT] : "Enter a tweet URL *",
    [CommandsEnum.TWITTER_RETWEET] : "Enter a tweet URL *",

    [CommandsEnum.INSTAGRAM_FLW_USER] : "Enter user URL *",
    [CommandsEnum.INSTAGRAM_LIKE_PST] : "Enter a post URL *",
    [CommandsEnum.INSTAGRAM_POST_CMT] : "Enter a post URL *",

    [CommandsEnum.FACEBOOK_LIKE_PAGE ] : "Enter a page URL",
    [CommandsEnum.FACEBOOK_LIKE_POST ] : "Enter a post URL *",
    [CommandsEnum.FACEBOOK_POST_COMMENT] : "Enter a post URL *",
    [CommandsEnum.FACEBOOK_SHARE_POST ] : "Enter a post URL *",

    [CommandsEnum.TIKTOK_FLW_USER] : "Enter a user URL *",
    [CommandsEnum.TIKTOK_LIKE] : "Enter a TikTok URL *",
    [CommandsEnum.TIKTOK_POST_CMT] : "Enter a TikTok URL *",

    [CommandsEnum.ONLYFANS_FOLLOW_USER]: "Enter a user URL *",

    [CommandsEnum.SOUNDCLOUD_FOLLOW_USER]: "Enter a user URL *",
    [CommandsEnum.SOUNDCLOUD_LIKE_TRACK] :"Enter a track URL *",
    [CommandsEnum.SOUNDCLOUD_REPOST_TRACK] : "Enter a track URL *",

    [CommandsEnum.SPOTIFY_FOLLOW_ARTIST]: "Enter an artist URL *",
    [CommandsEnum.SPOTIFY_LIKE_SONG_OR_ALBUM]: "Enter song or album URL *",

    [CommandsEnum.TWITCH_FOLLOW]: "Enter a user URL *",

    [CommandsEnum.DISCORD_JOIN_SERVER]: "Enter an invite URL *",

    [CommandsEnum.TELEGRAM_JOIN_CHANNEL]: "Enter a channel URL *",

    [CommandsEnum.BEHANCE_FOLLOW]: "Enter a user URL *",

    [CommandsEnum.LINKEDIN_CONNECT]: "Enter a profile URL *",
    [CommandsEnum.LINKEDIN_COMPANY_FOLLOW]: "Enter a company URL *",

    [CommandsEnum.PINTEREST_FOLLOW]: "Enter a profile URL *",
    [CommandsEnum.PINTEREST_SAVE]: "Enter a post URL *",

    [CommandsEnum.OTHER_VISIT_PAGE]: "Enter a URL *"
}

export function commandToInputLabel(command: CommandsEnum | string) {
    return commandToInputLabelMap[command as CommandsEnum] || "Enter a URL *"
}